import React, { useContext, useState } from "react";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import Messages from "./Messages";
import Input from "./Input";
import GroupMembers from "./GroupMembers";
import { ChatContext } from "../context/ChatContext";
import { AuthContext } from "../context/AuthContext";
import { generateGroupIcon } from "../utils/groupIcon";
import GroupAvatar from "./GroupAvatar";

const Chat = () => {
  const { data } = useContext(ChatContext);
  const { currentUser } = useContext(AuthContext);
  const [showGroupMembers, setShowGroupMembers] = useState(false);

  const getChatTitle = () => {
    if (data.isGroupChat) {
      return data.groupInfo?.name || "Group Chat";
    }
    return data.user?.displayName || "Unknown User";
  };

  const getChatSubtitle = () => {
    if (data.isGroupChat && data.groupInfo?.members) {
      return `${data.groupInfo.members.length} members`;
    }
    return null;
  };

  const handleTitleClick = () => {
    if (data.isGroupChat) {
      setShowGroupMembers(true);
    }
  };

  return (
    <div className="chat">
      <div className="chatInfo">
        <div 
          className={`chatTitleContainer ${data.isGroupChat ? 'clickable' : ''}`}
          onClick={handleTitleClick}
        >
          {data.isGroupChat ? (
            <GroupAvatar 
              groupName={data.groupInfo?.name} 
              size={40} 
              className="chatIcon" 
            />
          ) : (
            <img 
              src={data.user?.photoURL || "https://via.placeholder.com/40/6c757d/ffffff?text=U"} 
              alt="" 
              className="chatIcon" 
            />
          )}
          <div className="chatTitleText">
            <span className="chatTitle">{getChatTitle()}</span>
            {getChatSubtitle() && (
              <span className="chatSubtitle">{getChatSubtitle()}</span>
            )}
          </div>
        </div>
        
        <div className="chatRight">
          <span className="userName">{currentUser.displayName}</span>
          <img src={currentUser.photoURL} alt="" className="userProfilePic" />
          <button onClick={() => signOut(auth)} className="logoutBtn">logout</button>
        </div>
      </div>
      <Messages />
      <Input/>
      {showGroupMembers && (
        <GroupMembers onClose={() => setShowGroupMembers(false)} />
      )}
    </div>
  );
};

export default Chat;
